import { Injectable, EventEmitter, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavbarComponent } from '../component/navbar/navbar.component';
import { AdminNavbarComponent } from '../component/admin-navbar/admin-navbar.component';
import { FixedTopProgressBarComponent } from '../component/fixed-top-progress-bar/fixed-top-progress-bar.component';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  public navbar: NavbarComponent | AdminNavbarComponent;
  public navbarHideToggle = new EventEmitter();
  public progressBar: FixedTopProgressBarComponent;
  public loading: boolean;
  private hasStarted: boolean = false;
  private isDone: boolean = false;
  // Emite true SOMENTE quando o progress bar realmente apareceu (após o
  // debounce de 300ms) e false quando termina. Permite que consumers (ex.:
  // HomeComponent) sincronizem efeitos visuais — opacity, overlay — com o
  // mesmo timing da barra, sem flash em navegações rápidas.
  public loadingState$ = new BehaviorSubject<boolean>(false);
  private currentlyShown = false;

  private previousBehaviourDefined: {
    icon: string,
    onClick: () => void
  };

  constructor() { }

  setNavbar(navbar: NavbarComponent | AdminNavbarComponent): void {
    this.navbar = navbar;
    this.progressBar = navbar.progressBar;
  }

  changeBehavior(options: { icon: string, onClick: () => void }): void {
    setTimeout(() => {
      if (!this.previousBehaviourDefined) {
        this.previousBehaviourDefined = {
          icon: this.navbar.icon,
          onClick: this.navbar.toggleSidebar
        };
      }

      this.navbar.icon = options.icon;
      this.navbar.toggleSidebar = options.onClick;
    });
  }

  reset(): void {
    setTimeout(() => {
      if (this.previousBehaviourDefined) {
        this.changeBehavior(this.previousBehaviourDefined);
      } else {
        this.changeBehavior({
          icon: 'fa-bars',
          onClick: () => {
            this.navbar.sidebarService.toggle();
          }
        });
      }
    });
  }

  close(): void {
    setTimeout(() => {
      this.navbar.toggle(false);
      this.navbarHideToggle.emit({ open: false });
    });
  }

  open(): void {
    setTimeout(() => {
      this.navbar.toggle(true);
      this.navbarHideToggle.emit({ open: true });
    });
  }

  loadingStart(): void {
    this.hasStarted = true;
    this.isDone = false;
    // Dim do conteúdo dispara IMEDIATAMENTE — feedback visual ao clique.
    // O progress bar do topo continua debounced 300ms (evita flash em
    // navegação muito rápida) e é controlado separadamente abaixo.
    if (!this.currentlyShown) {
      this.currentlyShown = true;
      this.loadingState$.next(true);
    }
    setTimeout(() => {
      // Guard: `progressBar` só é populado em `setNavbar()`, chamado no
      // `ngOnInit` do AdminComponent/equivalente. A PRIMEIRA navegação
      // pra uma rota nova dispara `loadingStart()` ANTES do `ngOnInit`
      // do componente alvo, então o progressBar ainda é undefined.
      // Sem o cheque, o app crashava com TypeError ao entrar em /admin.
      if (!this.isDone && this.progressBar) {
        this.progressBar.start();
      }
    }, 300);
  }

  loadingStop(): void {
    if (this.hasStarted) {
      this.isDone = true;
      setTimeout(() => {
        if (this.progressBar) { this.progressBar.stop(); }
      }, 300);
    } else if (this.progressBar) {
      this.progressBar.stop();
    }
    // Undim imediato — o novo conteúdo já está pronto pra ser renderizado.
    if (this.currentlyShown) {
      this.currentlyShown = false;
      this.loadingState$.next(false);
    }
  }

  isLoading(): boolean {
    return !!this.progressBar && this.progressBar.mode !== undefined;
  }
}
